import { render, staticRenderFns } from "./Compatibility.vue?vue&type=template&id=70fefe6f&"
import script from "./Compatibility.vue?vue&type=script&lang=js&"
export * from "./Compatibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports